export default __webpack_public_path__ + "static/media/16418216954.f9ec447b.JPG";